module.exports = __webpack_public_path__ + "static/stm-laptop-d9deae256b5239b3189d345b1f5aae0b.png";